/**
 * @module app.pp
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { openGlobalModal, IModalData, IDialogOptions } from 'app/shared/elements/ess-global-modal';
import { isNullOrUndefined } from 'app/shared/lib/utilities';
import { MemberService, MemberType } from 'app/cd/services/member-service';
import { apiCall } from 'app/shared/lib/api/api';
import { guid } from 'app/shared/lib/guid';
import * as PP from 'app/pp/models/essette-api';

interface IPatientSummaryModelData {
    member: PP.AvailableMember,
    readonly?: boolean;
}

@autoinject()
export class PatientSummary extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView })
    protected memberId: string | null = null;

    protected readonly: boolean = false;

    protected id: guid = guid();

    protected memberType: MemberType = MemberType.Patient;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: MemberService,
        ...rest: any[]) {

        super(...rest);
    }

    protected async activate(model: IPatientSummaryModelData): Promise<void> {
        if(!model) { return; }

        if(!isNullOrUndefined(model.readonly)) {
            this.readonly = !!model.readonly;
        }

        if(model.member.id) {
            this.memberId = model.member.id;
        }
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
}

/**
 * Opens the patient summary modal with the global dialog
 * @param member The member information to use
 */
export function openPatientSummary(member: PP.AvailableMember, readonly: boolean = true): void {
    if(!member || !member.id) {
        throw new Error('Member is missing or invalid');
    }

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '10',
        helpTopic: 'pp.patient-summary',
        title: {
            key: 'cd:routes.patient.summary.$title',
            replace: { display: member.$display }
        },
        print: true,
        popout: {
            route: 'pp.patient.summary',
            params: { memberId: member.id }
        }
    };
    const modelData: IPatientSummaryModelData = {
        member: member,
        readonly: readonly
    };

    const modalData: IModalData = {
        componentId: 'app/pp/components/summary/patient-summary',
        modelData: modelData,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}
